import React from 'react';
import { IconProps } from '.';

const SvgCategoryBeautyFood = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M10.25 10.25V.56l-7.5 5.25v4.44h-1v3h-1v9.5h11.5v-2.174c.285.226.586.43.9.61v1.564h6.7v-1.563c2.308-1.331 3.9-3.919 3.9-6.901v-.75h-1.793c-.4-2.478-2.753-4.286-5.457-4.286-2.4 0-4.523 1.424-5.25 3.477V10.25h-1Zm-.987 4.5H2.25v6.5h8.5V19a8.062 8.062 0 0 1-1.487-4.25Zm-6.013-1.5v-1.5h6.5v1.5h-6.5Zm1-3h4.5V3.44l-4.5 3.15v3.66Zm16.174 3.286h-7.848c.385-1.55 1.94-2.786 3.924-2.786s3.538 1.237 3.924 2.786Zm-6.192 6.529c-1.82-.898-3.19-2.77-3.44-5.03h11.417c-.251 2.26-1.62 4.132-3.44 5.03l-.419.206v.979h-3.7v-.979l-.418-.206Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgCategoryBeautyFood;
